import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Group from 'reakit/Group';
var Group = styled(_Group).withConfig({
  displayName: "styled__Group",
  componentId: "sc-1cm5zaa-0"
})(["& > *{border-radius:4px;}& input:focus,& select:focus{z-index:1;position:relative;}& > *:first-child{& input,& select{", ";}}& > *:last-child{& input,& select{", ";}}& > *:not(:first-child):not(:last-child) > input,& > *:not(:first-child):not(:last-child) > select{border-radius:0;}&{", ";}"], function (props) {
  return props.vertical ? css(["border-bottom-right-radius:0;border-bottom-left-radius:0;"]) : css(["border-bottom-right-radius:0;border-top-right-radius:0;"]);
}, function (props) {
  return props.vertical ? css(["border-top-left-radius:0;border-top-right-radius:0;"]) : css(["border-top-left-radius:0;border-bottom-left-radius:0;"]);
}, theme('fannypack.Group.base'));
export default Group;
export { Group };